import React, { useState } from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBuilding, faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";

const OccupancyAccordion = ({ estimateData }) => {
  const [isOpen, setIsOpen] = useState(false);

  if (!estimateData) return null;

  const pax = estimateData.paxBreakdown || {};
  const adults = (pax.A || 0) + (pax.AEB || 0);
  const children = (pax.CwB || 0) + (pax.CnB || 0) + (pax.INF || 0);
  
  // Create a pseudo-room breakdown since the exact rooms aren't always available in estimateData
  // For the sake of the UI matching, we assume 2 adults per room if not specified
  const roomsCount = Math.max(1, Math.ceil(adults / 2));
  const rooms = [];
  let remainingAdults = adults;
  let remainingChildren = children;

  for (let i = 0; i < roomsCount; i++) {
    const rAdults = Math.min(2, remainingAdults);
    remainingAdults -= rAdults;
    const rChildren = Math.min(1, remainingChildren);
    remainingChildren -= rChildren;
    
    let label = `${rAdults}AD`;
    if (rChildren > 0) label += ` + ${rChildren}CH`;
    rooms.push(`ROOM ${i + 1}: ${label}`);
  }

  // Distribute leftovers
  if (remainingAdults > 0) rooms[rooms.length - 1] += ` + ${remainingAdults}AD`;
  if (remainingChildren > 0) rooms[rooms.length - 1] += ` + ${remainingChildren}CH`;

  return (
    <div className="border border-gray-200 rounded-lg bg-white mb-6 shadow-sm overflow-hidden">
      <button 
        onClick={() => setIsOpen(!isOpen)}
        className="w-full px-4 py-3 flex items-center justify-between focus:outline-none"
      >
        <div className="flex items-center gap-3">
          <FontAwesomeIcon icon={faBuilding} className="text-gray-500" />
          <span className="font-bold text-gray-800 text-sm">Occupancy Summary</span>
        </div>
        <FontAwesomeIcon icon={isOpen ? faChevronUp : faChevronDown} className="text-gray-400 text-sm" />
      </button>

      {isOpen && (
        <div className="px-4 pb-4 border-t border-gray-100 pt-3 bg-gray-50/30">
          <div className="flex flex-wrap gap-2 mb-3">
            {rooms.map((roomStr, idx) => (
              <span key={idx} className="bg-[#EAF3FA] text-[#4A729A] text-[11px] font-bold px-3 py-1.5 rounded-full uppercase tracking-wide">
                {roomStr}
              </span>
            ))}
          </div>
          <p className="text-xs text-gray-500 italic">
            Breakdown: {adults} Adults (12+ yrs), {children} Children
          </p>
        </div>
      )}
    </div>
  );
};

export default OccupancyAccordion;
